import * as ActionTypes from '../actions/types/DashboardActionTypes';
import * as RegistryOverviewActionTypes from '../actions/types/RegistryOverviewActionTypes';

const initialState = {
  loading: false,
  snapshot_view: {},
  status_center_view: {},
  progress_view: {},
  open_progress_tab_type: 'OVERVIEW',
  products: [],
  productsLoading: false,
  additionalProductsLoading: false,
};

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_DASHBOARD: {
      return Object.assign({}, state, { loading: true });
    }
    case ActionTypes.RECEIVE_DASHBOARD: {
      return Object.assign({}, state, action.payload, { loading: false });
    }
    // TODO: revisit; awkward action/reducer structure
    case RegistryOverviewActionTypes.REQUEST_PRODUCTS: {
      return { ...state, productsLoading: true };
    }
    case RegistryOverviewActionTypes.RECEIVE_PRODUCTS: {
      return { ...state, productsLoading: false, products: action.data };
    }
    case RegistryOverviewActionTypes.REQUEST_ADDITIONAL_PRODUCTS: {
      return { ...state, additionalProductsLoading: true };
    }
    case RegistryOverviewActionTypes.RECEIVE_ADDITIONAL_PRODUCTS: {
      return { ...state, additionalProductsLoading: false, products: action.data };
    }
    default:
      return state;
  }
};

export default dashboardReducer;



// WEBPACK FOOTER //
// ./src/reducers/dashboard.js